import { useState } from "react";
import { extractErrorMessage } from "../../../Utils/extractErrorMessage";
import toast from "react-hot-toast";
import { createVendorsGoodsNote, deleteVendorsGoodsNote, deleteVGNPhoto, getVendorsGoodsNote, getVendorsGoodsNoteById, getVGNMaterials, updateVendorsGoodsNote } from "../../../Services/VendorGoodsNoteService";
import { VGN_TOAST_MESSAGES } from "../VendorGoodsNote/constants";


export const useVendorGoodsNote = () => {
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    search: null,
    product: null,
    warehouse: null,
  });
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const onPageChange = (newPage) => setPage(newPage);

  const onPageSizeChange = (newSize) => {
    setRowsPerPage(newSize);
    setPage(1);
  };

  const fetchAllVGN = async (params) => {
    setLoading(true);
    var data = null;
    try {
      const response = await getVendorsGoodsNote({
        ...params,
        ...filters,
        limit: rowsPerPage,
        offset: (page - 1) * rowsPerPage,
      });
      if (response.status === 200) {
        setTotalPages(
          Math.max(1, Math.ceil((response.data?.count || 0) / rowsPerPage))
        );
        data = response.data?.results;
      } else {
        const msg =
          extractErrorMessage(response) || VGN_TOAST_MESSAGES.VGN_FETCH_FAILED;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || VGN_TOAST_MESSAGES.VGN_FETCH_FAILED
      );
    } finally {
      setLoading(false);
      return data;
    }
  };

  const fetchVGNMaterials = async (vgnId, params) => {
    try {
      const response = await getVGNMaterials(vgnId, params);
      if (response.status === 200) {
        return response.data.results;
      } else {
        toast.error(VGN_TOAST_MESSAGES.VGN_FETCH_MATERIALS_FAILED);
        return null;
      }
    } catch (error) {
      toast.error(VGN_TOAST_MESSAGES.VGN_FETCH_MATERIALS_FAILED);
      return null;
    }
  };

  const fetchVGNById = async (id) => {
    setLoading(true);
    var data = null;
    try {
      const response = await getVendorsGoodsNoteById(id);
      if (response.status === 200) {
        data = response.data;
      } else {
        const msg =
          extractErrorMessage(response) || VGN_TOAST_MESSAGES.VGN_FETCH_FAILED;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || VGN_TOAST_MESSAGES.VGN_FETCH_FAILED
      );
    } finally {
      setLoading(false);
      return data;
    }
  };

  const newVendorGoodsNote = async (payload) => {
    setLoading(true);
    var data = null;
    try {
      const response = await createVendorsGoodsNote(payload);
      if (response.status === 201) {
        data = response.data;
        const msg = VGN_TOAST_MESSAGES.VGN_CREATE_SUCCESS;
        toast.success(msg);
      } else {
        const msg =
          extractErrorMessage(response) ||
          VGN_TOAST_MESSAGES.VGN_CREATE_FAILED;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || VGN_TOAST_MESSAGES.VGN_CREATE_FAILED
      );
    } finally {
      setLoading(false);
      return data;
    }
  };

  const updateVGNDetails = async (vgnId, payload) => {
    setLoading(true);
    var data = null;
    try {
      const response = await updateVendorsGoodsNote(vgnId, payload);
      if (response.status === 200) {
        data = response.data;
        const msg = VGN_TOAST_MESSAGES.VGN_UPDATE_SUCCESS;
        toast.success(msg);
      } else {
        const msg =
          extractErrorMessage(response) || VGN_TOAST_MESSAGES.VGN_UPDATE_FAILED;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || VGN_TOAST_MESSAGES.VGN_UPDATE_FAILED
      );
    } finally {
      setLoading(false);
      return data;
    }
  };

  const deleteVendorGoodsNote = async (id) => {
    setLoading(true);
    var data = null;
    try {
      const response = await deleteVendorsGoodsNote(id);
      if (response.status === 204) {
        toast.success(VGN_TOAST_MESSAGES.VGN_DELETE_SUCCESS);
        data = true;
      } else {
        const msg =
          extractErrorMessage(response) ||
          VGN_TOAST_MESSAGES.VGN_DELETE_FAILED;
        toast.error(msg);
        data = false;
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || VGN_TOAST_MESSAGES.VGN_DELETE_FAILED
      );
      data = false;
    } finally {
      setLoading(false);
      return data;
    }
  };

    const deleteVGNFile = async (id) => {
      setLoading(true);
      var data = null;
      try {
        const response = await deleteVGNPhoto(id);
        if (response.status === 200) {
          toast.success(VGN_TOAST_MESSAGES.FILE_DELETE_SUCCESS);
          data = true;
        } else {
          const msg =
            extractErrorMessage(response) ||
            VGN_TOAST_MESSAGES.FILE_DELETE_FAILED;
          toast.error(msg);
          data = false;
        }
      } catch (error) {
        toast.error(
          extractErrorMessage(error) || VGN_TOAST_MESSAGES.FILE_DELETE_FAILED
        );
        data = false;
      } finally {
        setLoading(false);
        return data;
      }
    };

  return {
    loading,
    filters,
    setFilters,
    page,
    totalPages,
    rowsPerPage,
    onPageChange,
    onPageSizeChange,
    fetchAllVGN,
    deleteVendorGoodsNote,
    newVendorGoodsNote,
    fetchVGNById,
    updateVGNDetails,
    fetchVGNMaterials,
    deleteVGNFile,
  };
};
